import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    results: null,
    pagination: null
  },
  mutations: {
    SET_PRODUCTS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
    }
  },
  actions: {
    async load({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get("/admin/products", {
          params: params
        });
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_PRODUCTS", res.data);
      } catch (error) {
        throw error;
      }
    },
    async save({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/admin/products/${params.id}`,
          {
            name: params.name,
            ERPCode: params.ERPCode,
            harmonyCode: params.harmonyCode,
            isSubscription: params.isSubscription
          }
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        throw error;
      }
    },
    async add({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/admin/products", {
          name: params.name,
          ERPCode: params.ERPCode,
          harmonyCode: params.harmonyCode,
          isSubscription: params.isSubscription
        });
        if (res.status != 201) throw errors.handleHTTPError(res);
      } catch (error) {
        throw error;
      }
    },
    async delete({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(`/admin/products/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    products: state => {
      const results = {
        results: state.results,
        pagination: state.pagination
      };
      return results;
    }
  }
};
